import { render, staticRenderFns } from "./LawMatterOutcomeList.vue?vue&type=template&id=3efe4181&"
import script from "./LawMatterOutcomeList.vue?vue&type=script&lang=js&"
export * from "./LawMatterOutcomeList.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterOutcomeList.vue?vue&type=style&index=0&id=3efe4181&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports